import { Opcoes } from './../../model/pesquisa';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Pesquisa } from '../../model/pesquisa';
import { PesquisaService } from '../../service/pesquisa.service';

@Component({
  selector: 'app-admin-pesquisa-form',
  templateUrl: './admin-pesquisa-form.component.html',
  styleUrls: ['./admin-pesquisa-form.component.css']
})
export class AdminPesquisaFormComponent implements OnInit {

  item: Pesquisa;
  opcao: Opcoes;

  constructor(private router: Router, private service: PesquisaService, private messageService: MessageService) { }

  ngOnInit() {
      this.item = <Pesquisa>{};
      this.opcao = <Opcoes> {};
      this.item.id = this.service.criaId();
      this.item.ativo = true;
  }

  salvar() {
    const task = this.service.salvar(this.item);
    task.then(ret => {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Registro Salvo com Sucesso' });
      this.router.navigate(['admin/pesquisa']);
    }).catch(e => {
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao salvar' });
    });
  }

  adicionar() {
    this.opcao.id = this.service.criaId();
    this.opcao.quantidade = 0;
    if (this.item.opcoes == null) {
      this.item.opcoes = [];
    }
    this.item.opcoes.push(this.opcao);
    this.opcao = <Opcoes> {};
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/admin-pesquisa-form/admin-pesquisa-form.component.ts